<script setup lang="ts">
import {PropType, Ref, ref} from "vue";
import {IonButton, IonIcon} from "@ionic/vue";
import date from "@/helper/datetime/date";
import {
    Availability,
    AvailabilityCoordinate,
    Day,
    Demand,
    DemandJoDaShTiFragment
} from "@/graphql/generated/graphql";
import Modal from "@/components/Modal.vue";
import {
    convertToDemandJoDaShTi,
    askChatForDemandOn,
    joDaShTiMatcher,
    containsJoDaShTi, removeAvailabilityCoordinateFromDay, addAvailabilityCoordinateToDay
} from "@/helper/demandBrowser";
import datetimeRange from "@/helper/datetime/datetimeRange";
import {arrayClone} from "@/helper/array";
import {KapitelIcon} from "@/helper/icon";
import JoDaShTiListItem from "@/views/JoDaShTiListItem.vue";
import {kapitelDateString} from "@/graphql/kapitelTypes";

const props = defineProps({
    day: {
        type: Object as PropType<Day>,
        required: true
    },
    additionalAvailabilitySummary: {
        type: Array as PropType<AvailabilityCoordinate[]> | [],
        required: false,
        default: [],
    },
    demandSuggestions: {
        type: Array as PropType<Demand[]>,
        required: false,
        default: [],
    },
});

const isOpen = defineModel({type: Boolean, default: false})

// const emit = defineEmits<{
//     add: [d: DemandJoDaShTi]
//     remove: [d: DemandJoDaShTi]
// }>()

const localAdditionalAvailabilities : Ref<DemandJoDaShTiFragment[]> = ref([])
const localDemandSuggestions : Ref<DemandJoDaShTiFragment[]> = ref([])

/**
 * create local copy on modal-present, decoupled from outside changes
 * // prevent doubles by filtering suggestions to not match any existing additionalAvailability
 */
const init = () => {
    localAdditionalAvailabilities.value = props.additionalAvailabilitySummary
        .map(convertToDemandJoDaShTi)
    localDemandSuggestions.value = props.demandSuggestions
        .map(convertToDemandJoDaShTi)
        // .filter(d => !localAdditionalAvailabilities.value.some(a => joDaShTiMatcher(a,d)))
}

const isActive = (x:DemandJoDaShTiFragment) => props.day?.availability ? containsJoDaShTi(props.day?.availability.additionalAvailabilityCoordinates, x) : false

const toggle = async (x:DemandJoDaShTiFragment) => isActive(x)
    ? await removeAvailabilityCoordinateFromDay(x, props.day)
    : await addAvailabilityCoordinateToDay(x, props.day)


</script>

<template>
    <Modal
        @view:willPresent="init"
        v-model="isOpen"
        title="Zusätzliche Verfügbarkeiten"
        :subtitle="'am ' + date.formatKapitelDate(day.date)"
    >
        <template v-if="localAdditionalAvailabilities.length > 0">
<!--            <h3>Zusätzlich Verfügbar für</h3>-->
            <JoDaShTiListItem
                v-for="aa in localAdditionalAvailabilities"
                :joDaShTi="aa"
                @toggle="toggle(aa)"
                :toggleState="isActive(aa)"
                :considered="isActive(aa) /*TODO:*/"
                :showJobsiteLabel="true"
            />
        </template>

        <h3 v-if="localAdditionalAvailabilities.length > 0 && localDemandSuggestions.length > 0" >Dienstvorschläge</h3>

        <template v-if="localDemandSuggestions.length > 0">
            <JoDaShTiListItem
                v-for="d in localDemandSuggestions"
                :joDaShTi="d"
                @toggle="toggle(d)"
                :toggleState="isActive(d)"
                :considered="isActive(d) /*TODO:*/"
                :showJobsiteLabel="true"
            />
        </template>

<!--        <h3>Offene Dienste</h3>-->
        <IonButton class="footerButton" color="light" @click="askChatForDemandOn(day.date)">
            <IonIcon :icon="KapitelIcon.chat" slot="start"/>
            Weitere offene Dienste suchen
        </IonButton>

        <template #actions="{dismiss}">
            <IonButton color="primary" @click="dismiss">Zurück</IonButton>
        </template>
    </Modal>
</template>
<style scoped lang="scss">
    h3:not(:first-child),
    .footerButton{
        padding-top: 2em
    }
</style>
